import { render } from "./Horaires.vue?vue&type=template&id=045ac01a"
import script from "./Horaires.vue?vue&type=script&lang=js"
export * from "./Horaires.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__